import { render, staticRenderFns } from "./SystemCodeIndex.vue?vue&type=template&id=1ca68fff&scoped=true&"
import script from "./SystemCodeIndex.vue?vue&type=script&lang=js&"
export * from "./SystemCodeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca68fff",
  null
  
)

export default component.exports